import { render, staticRenderFns } from "./RoleConfig.vue?vue&type=template&id=bf136462&scoped=true&"
import script from "./RoleConfig.vue?vue&type=script&lang=js&"
export * from "./RoleConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf136462",
  null
  
)

export default component.exports